import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_245: DocMigration = {
  maxSchemaVersion: "0.0.245",
  description: "Migration plan drawing options for rail",
  apply(json: any) {
    if (json.railings) {
      for (const railingId in json.railings) {
        const railing = json.railings[railingId];

        if (railing) {
          const addToShowroomPlan = railing.addToShowroomPlan ?? false;
          delete railing.addToShowroomPlan;
          const addToBrochurePlan = railing.addToBrochurePlan ?? false;
          delete railing.addToBrochurePlan;

          if (!railing.settingsOverride) {
            railing.settingsOverride = {};
          }

          railing.settingsOverride.includeRailInShowRoomPlan = addToShowroomPlan;
          railing.settingsOverride.includeRailInBrochurePlan = addToBrochurePlan;
          railing.settingsOverride.includeRailInPlanDrawing = true;

          railing.settingsOverride.includePostsInShowRoomPlan = addToShowroomPlan;
          railing.settingsOverride.includePostsInBrochurePlan = false;
          railing.settingsOverride.includePostsInPlanDrawing = false;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_245;
